// extracted by mini-css-extract-plugin
export default {"Discard":"JobTable_Discard__FVg6a","Header":"JobTable_Header__Uopoq"};